import { Component, Inject, Input } from "@angular/core";
import { LOCATION, WINDOW } from "@tylertech/shared-module";
import { IAppRegistrationModel } from "@tylertech/tyler-api-types";
import { NavigationService, RouteInfoService } from "../../../services";

export const enum SessionKey
{
    current_module = "current_module",
    module_display = "module_display",
    module_icon = "module_icon",
    module_illustration = "module_illustration",
    module_illustrationText = "module_illustrationText",
}

@Component({
    selector: "application-link",
    templateUrl: "./applicationLink.tmpl.html",
    styleUrl: "./applicationLink.component.scss",
    standalone: false
})
export class ApplicationLinkComponent
{
    @Input() readonly application: IAppRegistrationModel;
    @Input() readonly autoFocus: boolean = false;

    class: string;

    private _id = "";

    constructor(
        @Inject(WINDOW) private readonly window: Window & globalThis.Window,
        @Inject(LOCATION) private readonly location: Location,
        private readonly $navigationService: NavigationService,
        private readonly $routeInfoService: RouteInfoService
    ) { }

    get iconStyle(): Record<string, string>
    {
        /* eslint-disable @typescript-eslint/naming-convention */
        return {
            "background-color": this.application.Color,
        };
        /* eslint-enable @typescript-eslint/naming-convention */
    }

    get id(): string
    {
        if(this._id === "")
        {
            this._id = this.application.Name.replace(/ /g, "");
        }
        return this._id;
    }

    onClick(): void
    {
        if (this.application.IsExternal)
        {
            this.location.href = this.application.Link;
            return;
        }

        if (this.application.Link === "ReportJira")
        {
            const tenant = this.$routeInfoService.tenant;
            const link = `/${tenant}/apps/form/?path=_ReportJiraForm&n=true&$filter=From%20eq%20%27${encodeURIComponent(window.location.href)}%27`;
            this.window.open(link, "_blank");
            return;
        }

        if (!this.application.ModuleName)
        {
            // TODO(DO-4549) - We never read this data here. So who are we "communicating" with? And why are we doing it through session storage?
            this.window.sessionStorage.removeItem(SessionKey.current_module);
            this.window.sessionStorage.removeItem(SessionKey.module_display);
            this.window.sessionStorage.removeItem(SessionKey.module_icon);
            this.window.sessionStorage.removeItem(SessionKey.module_illustration);
            this.window.sessionStorage.removeItem(SessionKey.module_illustrationText);
        }
        else
        {
            // TODO(DO-4549) - We never read this data here. So who are we "communicating" with? And why are we doing it through session storage?
            this.window.sessionStorage.setItem(SessionKey.current_module, this.application.ModuleName);
            this.window.sessionStorage.setItem(SessionKey.module_display, this.application.ModuleDisplayText);
            this.window.sessionStorage.setItem(SessionKey.module_icon, this.application.IconSource);
            this.window.sessionStorage.setItem(SessionKey.module_illustration, this.application.IllustrationName);
            this.window.sessionStorage.setItem(SessionKey.module_illustrationText, this.application.IllustrationText);
        }

        this.$navigationService.navigateToApp(this.application.Link);
    }
}
